import clsx from 'clsx';
import {makeStyles} from '@mui/styles';
import {COLORS} from 'theme/MainTheme';
import {Audio} from 'components';
import {DownloadButton, PlayButton, PauseButton} from './buttons';
import ProgressBar from './ProgressBar';
import useAudioPlayer from './useAudioPlayer';

const useStyles = makeStyles(() => ({
  controls: {
    flexGrow: 1,
    margin: '0 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  player: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 0',
    backgroundColor: COLORS.DARKER_BLUE,
  },
}), { name: 'AudioPlayer' });

export type AudioPlayerProps = {
  className?: string;
  id: string;
  url: string;
  handleDownload: () => void;
};

const AudioPlayer = ({ className, id, url, handleDownload }: AudioPlayerProps) => {

  const elementId = `audio-player-${id}`;
  const { curTime, duration, playing, setPlaying, setClickedTime } = useAudioPlayer(elementId);
  const classes = useStyles();

  return (
    <div className={clsx([className, classes.player])}>
      <Audio id={elementId} src={url} labelId="audio" />

      <div className={classes.controls}>
        <ProgressBar
          id={id}
          curTime={curTime}
          duration={duration}
          onTimeUpdate={(time) => setClickedTime(time)}
        />

        {playing
        ? <PauseButton onClick={() => setPlaying(false)} />
        : <PlayButton onClick={() => setPlaying(true)} />
        }

        <DownloadButton onClick={handleDownload} />
      </div>
    </div>
  );
};

export default AudioPlayer;